// Fichier généré automatiquement
import React from 'react'
import styles from '../styles/Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>© 2026 zTravel Consulting — All rights reserved</p>
    </footer>
  )
}

export default Footer
